package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ContrastW500Rounded: ImageVector
    get() {
        if (_contrastW500Rounded != null) {
            return _contrastW500Rounded!!
        }
        _contrastW500Rounded = Builder(name = "ContrastW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(320.89f, 856.03f)
                quadToRelative(-74.43f, -32.1f, -129.63f, -87.29f)
                quadToRelative(-55.19f, -55.2f, -87.29f, -129.63f)
                quadToRelative(-32.1f, -74.44f, -32.1f, -159.11f)
                quadToRelative(0.0f, -84.67f, 32.1f, -159.11f)
                quadToRelative(32.1f, -74.43f, 87.29f, -129.63f)
                quadToRelative(55.2f, -55.19f, 129.63f, -87.29f)
                quadToRelative(74.44f, -32.1f, 159.11f, -32.1f)
                quadToRelative(84.67f, 0.0f, 159.11f, 32.1f)
                quadToRelative(74.43f, 32.1f, 129.63f, 87.29f)
                quadToRelative(55.19f, 55.2f, 87.29f, 129.63f)
                quadToRelative(32.1f, 74.44f, 32.1f, 159.11f)
                quadToRelative(0.0f, 84.67f, -32.1f, 159.11f)
                quadToRelative(-32.1f, 74.43f, -87.29f, 129.63f)
                quadToRelative(-55.2f, 55.19f, -129.63f, 87.29f)
                quadToRelative(-74.44f, 32.1f, -159.11f, 32.1f)
                quadToRelative(-84.67f, 0.0f, -159.11f, -32.1f)
                close()
                moveTo(522.87f, 793.65f)
                quadToRelative(117.09f, -15.95f, 195.67f, -103.9f)
                quadTo(797.13f, 601.8f, 797.13f, 480.0f)
                quadToRelative(0.0f, -121.09f, -78.59f, -209.27f)
                quadToRelative(-78.58f, -88.19f, -195.67f, -104.14f)
                verticalLineToRelative(627.06f)
                close()
            }
        }
        .build()
        return _contrastW500Rounded!!
    }

private var _contrastW500Rounded: ImageVector? = null
